const Offer = () => (
  <section id="offers" className="my-5 text-white container">
    <div className="text-center">
      <span className="spanEffect mt-4">Services</span>
      <h1
        className="text-white mt-2"
        style={{ fontSize: "2.5rem", fontWeight: 600, lineHeight: 2 }}
      >
        What I Offer
      </h1>
    </div>

    <div className="row mt-5">
      {/* Frontend Development */}
      <div className="col-md-6 mb-4">
        <div className="p-5 serviceCard">
          <div className="d-flex justify-content-between flex-wrap gap-5">
            <div className="icon">
              <img
                src="https://cdn-icons-png.flaticon.com/512/919/919827.png"
                alt="Frontend Development"
                width="80"
              />
            </div>
            <div className="d-flex flex-column">
              <h3>Frontend Development</h3>
              <p className="pEffect">
                Learn how to build responsive and interactive websites using
                HTML, CSS, JavaScript, and modern frameworks like React or Vue.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Backend Development */}
      <div className="col-md-6 mb-4">
        <div className="p-5 serviceCard">
          <div className="d-flex justify-content-between flex-wrap gap-5">
            <div className="icon">
              <img
                src="https://cdn-icons-png.flaticon.com/512/5968/5968322.png"
                alt="Backend Development"
                width="80"
              />
            </div>
            <div className="d-flex flex-column">
              <h3>Backend Development</h3>
              <p className="pEffect">
                Master server-side programming with Node.js, Express, and APIs —
                learn how to handle authentication, routing, and business logic
                efficiently.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Database Management */}
      <div className="col-md-6 mb-4">
        <div className="p-5 serviceCard">
          <div className="d-flex justify-content-between flex-wrap gap-5">
            <div className="icon">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4248/4248443.png"
                alt="Database Management"
                width="80"
              />
            </div>
            <div className="d-flex flex-column">
              <h3>Database Management</h3>
              <p className="pEffect">
                Understand how to design and manage databases using MySQL,
                MongoDB, and Firebase to create scalable and efficient systems.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Full Stack Projects */}
      <div className="col-md-6 mb-4">
        <div className="p-5 serviceCard">
          <div className="d-flex justify-content-between flex-wrap gap-5">
            <div className="icon">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1055/1055687.png"
                alt="Full Stack Projects"
                width="80"
              />
            </div>
            <div className="d-flex flex-column">
              <h3>Full Stack Projects & Mentorship</h3>
              <p className="pEffect">
                Build complete web applications from scratch. Get mentorship on
                best practices, version control with Git, and deploying on
                platforms like Vercel or Render.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Offer;
